"use strict";
function searchStringContainsSimilar(queryObj) {
    if (!queryObj || !Array.isArray(queryObj.or)) {
        return false;
    }
    for (const orClause of queryObj.or) {
        const fieldName = Object.keys(orClause)[0];
        if (fieldName) {
            const fieldValue = orClause[fieldName];
            if (typeof fieldValue === 'object' &&
                fieldValue !== null &&
                'similar' in fieldValue) {
                return true;
            }
        }
    }
    return false;
}
function containsSimilarityKeyword(inputString) {
    if (typeof inputString !== 'string') {
        return false;
    }
    return inputString.includes('similarity.');
}
module.exports = {
    searchStringContainsSimilar,
    containsSimilarityKeyword,
};
